<template>
    <form @submit.prevent="submit">
        <SavingNotification>
            Sending...
        </SavingNotification>

        <div class="field has-addons">
            <div class="control is-expanded">
                <b-input
                    v-model="emailAddress"
                    v-validate="{ required: true, email: true }"
                    name="Email"
                    placeholder="Search by email address"
                />
            </div>
            <div class="control">
                <b-button
                    type="is-info"
                    :disabled="isSending"
                    native-type="submit"
                >
                    Search
                </b-button>
            </div>
        </div>

        <span
            v-show="emailAddress"
            class="is-size-7 has-text-danger"
        >
            {{ errors.first('Email') }}
        </span>
    </form>
</template>

<script>
import { mapState } from 'vuex';
import Form from '../mixins/form.js';

export default {
    mixins: [
        Form,
    ],

    data() {
        return {
            rows: [],
            emailAddress: '',
            isFetching: false,
        };
    },

    computed: {
        ...mapState('users', [
            'users',
        ])
    },

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
            .then((result) => {
                if (! result) {
                    return this.parseClientErrors();
                }

                this.isSending = true;

                this.$store.dispatch('users/getUsers', this.emailAddress)
                .then((response) => {
                    this.statusMessage = response.data.message;
                    this.statusType = 'success';
                    this.isSuccess = true;

                    // no users
                    if(! this.users.length) {
                        return this.$buefy.dialog.alert('No users have been found matching this email address.');
                    }

                    // multiple users
                    if(this.users.length > 1) {
                        return this.$buefy.dialog.alert('Multiple users have been found, resolve the duplicates to continue.');
                    }

                    this.$buefy.toast.open(`Switching to ${this.users[0].strEmail}`);
                    window.location.href = `/admin/impersonate/${this.users[0].APIUserPK}`;
                })
                .catch((error) => {
                    this.parseServerErrors(error);
                    this.isSuccess = false;
                })
                .then(() => {
                    this.isSending = false;
                });
            });
        },
    },
};
</script>
